import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { LiftsService } from '@app/lift/service/lifts.service';
import { Lift } from '@app/shared/models/lift.model';
import { Slot } from '@app/shared/models/slot.model';
import { Tray } from '@app/shared/models/tray.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-select-slot-form',
  templateUrl: './select-slot-form.component.html',
  styleUrls: ['./select-slot-form.component.scss']
})
export class SelectSlotFormComponent implements OnInit {
  @Input() initialLiftId: number;
  @Input() initialTrayId: number;
  @Input() showValidations = false;
  @Input() isLoading: boolean;

  liftForm: UntypedFormGroup;
  trayForm: UntypedFormGroup;
  slotForm: UntypedFormGroup;

  selectedLift: Lift = null;
  selectedTray: Tray = null;
  selectedSlot: Slot = null;
  lifts: Lift[] = [];
  trays: Tray[] = [];
  slots: Slot[] = [];


  ngOnInit() {
    this.liftForm = new UntypedFormGroup({
      lift: new UntypedFormControl(this.selectedLift, [
        Validators.required
      ]),
    });

    this.trayForm = new UntypedFormGroup({
      tray: new UntypedFormControl(this.selectedTray, [
        Validators.required
      ]),
    });

    this.slotForm = new UntypedFormGroup({
      slot: new UntypedFormControl(this.selectedSlot, [
        Validators.required
      ]),
    });
  }

  constructor(
    private liftsService: LiftsService,
    private translate: TranslateService,
  ) {}

  get getFormValue() {
    return {
      lift: this.liftForm.value.lift,
      tray: this.trayForm.value.tray,
      slot: this.slotForm.value.slot,
    };
  }

  onSelectLift(lift: Lift) {
    if (!lift) { return; }

    this.liftsService.getLift(lift.id).subscribe((data) => {
      this.selectedLift = data as Lift;
      this.trays = this.selectedLift.trays;
      this.selectedTray = null;
      this.selectedSlot = null;
      this.trayForm.controls['tray'].setValue(null);
      this.slotForm.controls['slot'].setValue(null);
    });
  }

  onSelectTray(tray: Tray) {
    if (!tray) { return; }

    this.selectedTray = tray;
    this.slots = this.selectedTray.slots;
    this.selectedSlot = null;
    this.slotForm.controls['slot'].setValue(null);
  }

  onSelectSlot(slot: Slot) {
    if (!slot) { return; }
    this.selectedSlot = slot;
  }

  getLifts() {
    this.liftsService.getLifts().subscribe((data) => {
        this.lifts = (data as any).items;

        // Remove current lift
        if (this.initialLiftId) {
          const index = this.lifts.indexOf(this.lifts.find((lift) => lift.id === this.initialLiftId));
          this.lifts.splice(index, 1);
        }

        this.liftForm.controls['lift'].setValue(this.selectedLift);
    });
  }

  reset() {
    this.liftForm.reset();
    this.trayForm.reset();
    this.slotForm.reset();

    this.selectedLift = null;
    this.selectedTray = null;
    this.selectedSlot = null;
  }
}
